import { Theme } from '@material-ui/core/styles';

import { getStyles, getUseClasses, makeStyles, mockTheme } from '@core/theme/utils/with-styles';

const stylesFn = (_: Theme) =>
  getStyles({
    root: {},
    rootFullWidth: {},

    labelRoot: {},
    labelError: {},

    select: {},
    selectActive: {},
    selectDisabled: {},
    selectError: {},
    selectHovered: {},

    value: {},
    valueIcon: {},
    valueDisabled: {},
    valueMultiple: {},
    valuePlaceholder: {},
    valuePlaceholderEllipsis: {},
    selectorValueText: {},

    menu: {},
    menuItem: {},
    menuItemDisabled: {},
    menuItemIcon: {},
    menuItemText: {},
    autoMenuHeight: {},

    helperText: {},
    tooltip: { display: 'flex', width: '100%' },
  });
const stylesResult = stylesFn(mockTheme);

const makeClasses = makeStyles<keyof typeof stylesResult>('MultiSelect', stylesFn);

export const useMultiSelectClasses = getUseClasses<keyof typeof stylesResult>(makeClasses);
